import angular from 'angular';

ItemorderService.$inject = ['$resource', 'appconfig'];

function ItemorderService($resource, appconfig) {
    return $resource(appconfig.apiEndpoint + "/itemorder");
}

export default angular.module('itemorder.service', [])
    .factory('ItemorderService', ItemorderService)
    .name;
